import axios from "axios";
import { alertController } from "@ionic/vue";

// Flag to prevent multiple 401 alerts at the same time
let isHandling401 = false;

// Request interceptor to add JWT token to requests
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle 401 errors
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.response && error.response.status === 401) {
      // Check if user was actually logged in before this 401 error
      const hadToken = localStorage.getItem("token");

      // Check if this is a login/auth request (should not trigger session expired)
      const requestUrl = error.config?.url || "";
      const isAuthRequest =
        requestUrl.includes("/auth/login") ||
        requestUrl.includes("/auth/signup") ||
        requestUrl.includes("/auth/google") ||
        requestUrl.includes("/auth/facebook");

      // Only show "Session Expired" if user was logged in and this is NOT a login attempt
      if (hadToken && !isAuthRequest && !isHandling401) {
        isHandling401 = true;

        // Clear all user data from localStorage
        localStorage.removeItem("token");
        localStorage.removeItem("id");
        localStorage.removeItem("name");
        localStorage.removeItem("email");
        localStorage.removeItem("mobile");
        localStorage.removeItem("provider");
        localStorage.removeItem("isVerified");
        localStorage.removeItem("userType");
        localStorage.removeItem("cafeId");

        // Show notification to user
        const alert = await alertController.create({
          header: "Session Expired",
          message: "Your session has expired. Please log in again.",
          buttons: ["OK"],
        });

        await alert.present();

        // Wait for alert to be dismissed, then redirect to login
        await alert.onDidDismiss();

        // Reset flag before redirect
        isHandling401 = false;

        window.location.href = "/welcome";
      }
    }

    return Promise.reject(error);
  }
);

export default axios;
